import React from 'react';
import { connect, Provider } from "react-redux";

export function registerReducer(initialState, responders) {
  return (state = initialState, { type, ...action }) => {
    if (responders[type]) {
      return Object.assign({}, state, responders[type](state, action));
    }
    return state;
  };
}

export function wrapStore(Component, initStore, actions, mapStateToProps = null) {

  const WrappedComponent = connect(
    mapStateToProps ? mapStateToProps : state => state,
    actions,
  )(Component);

  class Wrapper extends React.Component {

    render() {
      const store = initStore();

      return (
        <Provider store={store}>
          <WrappedComponent {...this.props} />
        </Provider>
      );
    }
  }

  return Wrapper;
}

/*********************************
 * Dispatches three actions for an
 * async operation represented by
 * promise.
 ********************************/
export function dispatchAsync(dispatch, promise, types, actions = {}) {
  const { pending, success, failure } = types;

  dispatch(pending(actions));
  promise
    .then(response => dispatch(success({
      ...actions,
      response,
    })))
    .catch(error => dispatch(failure({
      ...actions,
      error,
      response: error.responseJSON,
    })));
}

export function createWithFormData(formData, url, normalizeFunc) {
  return new Promise(function(resolve, reject) {
    $.ajax({
      url: url,
      dataType: 'json',
      type: 'POST',
      data: formData,
      contentType: false,
      processData: false
    }).then(
      function( data, response ){ resolve( normalizeFunc(data) ); },
      function( data ){ reject( normalizeFunc(data) ); }
    );
  });
}
